import AdminServices from './AdminServices';

export default AdminServices;
